import { initializeApp } from 'firebase/app';
import "firebase/firestore";
import { getFirestore } from 'firebase/firestore';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut as fbSignOut,
  onAuthStateChanged,
} from "firebase/auth";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCu_qWXAenzLbhiddVdfQMay1-obHvkYEs",
  authDomain: "mantra-eddda.firebaseapp.com",
  projectId: "mantra-eddda",
  storageBucket: "mantra-eddda.firebasestorage.app",
  messagingSenderId: "726101969882",
  appId: "1:726101969882:web:26fff9e41e4a333b500ee3",
  measurementId: "G-ZEYSJML6EK"
};

firebase.initializeApp(firebaseConfig)

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider);
}

export function signOut() {
  return fbSignOut(auth);
}

export function subscribeAuth(onChange) {
  return onAuthStateChanged(auth, onChange);
}

// export { auth };